import get from 'lodash.get';

export const selectSelectedViewId = (state) => get(state, 'selectedViewId', 'outstanding');
export const selectSearchPerformed = (state) => get(state, 'searchPerformed', false);
export const selectSearchData = (state) => get(state, 'searchData', '');
export const selectStatusCountMap = (state) => get(state, 'statusCountMap');
export const selectSearchTotalCount = (state) => get(state, 'count');
